// Social media URL patterns
// Maps icon names to their URL prefixes and placeholders
// This helps auto-fill the URL based on just the username

const socialUrlPatterns = {
  // Major Social Networks
  'Facebook': { prefix: 'https://facebook.com/', placeholder: 'username' },
  'Instagram': { prefix: 'https://instagram.com/', placeholder: 'username' },
  'Twitter': { prefix: 'https://twitter.com/', placeholder: 'username' },
  'Twitter (X)': { prefix: 'https://x.com/', placeholder: 'username' },
  'LinkedIn': { prefix: 'https://linkedin.com/in/', placeholder: 'username' },
  'TikTok': { prefix: 'https://tiktok.com/@', placeholder: 'username' },
  'Snapchat': { prefix: 'https://snapchat.com/add/', placeholder: 'username' },
  'Pinterest': { prefix: 'https://pinterest.com/', placeholder: 'username' },
  'Reddit': { prefix: 'https://reddit.com/user/', placeholder: 'username' },
  'Tumblr': { prefix: 'https://', placeholder: 'username.tumblr.com' },
  
  // Newer Social Networks
  'Bluesky': { prefix: 'https://bsky.app/profile/', placeholder: 'username' },
  'Mastodon': { prefix: 'https://', placeholder: 'instance/@username' },
  'Threads': { prefix: 'https://threads.net/@', placeholder: 'username' },
  'OnlyFans': { prefix: 'https://onlyfans.com/', placeholder: 'username' },
  'BeReal': { prefix: 'https://bere.al/', placeholder: 'username' },
  
  // Video Platforms
  'YouTube': { prefix: 'https://youtube.com/@', placeholder: 'username' },
  'Twitch': { prefix: 'https://twitch.tv/', placeholder: 'username' },
  
  // Communication
  'Discord': { prefix: 'https://discord.gg/', placeholder: 'invite-code' },
  'Skype': { prefix: 'https://join.skype.com/', placeholder: 'invite-code' },
  'Slack': { prefix: 'https://', placeholder: 'workspace.slack.com' },
  'Telegram': { prefix: 'https://t.me/', placeholder: 'username' },
  'WhatsApp': { prefix: 'https://wa.me/', placeholder: 'phone-number' },
  
  // Music & Audio
  'Spotify': { prefix: 'https://open.spotify.com/user/', placeholder: 'username' },
  'Soundcloud': { prefix: 'https://soundcloud.com/', placeholder: 'username' },
  'Last.fm': { prefix: 'https://last.fm/user/', placeholder: 'username' },
  'Bandcamp': { prefix: 'https://', placeholder: 'username.bandcamp.com' },
  'Mixcloud': { prefix: 'https://mixcloud.com/', placeholder: 'username' },
  'Discogs': { prefix: 'https://discogs.com/user/', placeholder: 'username' },
  
  // Blogging & Writing
  'Medium': { prefix: 'https://medium.com/@', placeholder: 'username' },
  'Dev.to': { prefix: 'https://dev.to/', placeholder: 'username' },
  'WordPress': { prefix: 'https://', placeholder: 'sitename.wordpress.com' },
  'Blogger': { prefix: 'https://', placeholder: 'blogname.blogspot.com' },
  'Substack': { prefix: 'https://', placeholder: 'username.substack.com' },
  
  // Professional & Portfolio
  'Behance': { prefix: 'https://behance.net/', placeholder: 'username' },
  'Dribbble': { prefix: 'https://dribbble.com/', placeholder: 'username' },
  'Etsy': { prefix: 'https://etsy.com/shop/', placeholder: 'shop-name' },
  'Flickr': { prefix: 'https://flickr.com/photos/', placeholder: 'username' },
  'Unsplash': { prefix: 'https://unsplash.com/@', placeholder: 'username' },
  'DeviantArt': { prefix: 'https://', placeholder: 'username.deviantart.com' },
  
  // Developer Platforms
  'GitHub': { prefix: 'https://github.com/', placeholder: 'username' },
  'GitLab': { prefix: 'https://gitlab.com/', placeholder: 'username' },
  'Stack Overflow': { prefix: 'https://stackoverflow.com/users/', placeholder: 'user-id' },
  'Codepen': { prefix: 'https://codepen.io/', placeholder: 'username' },
  
  // Gaming
  'Steam': { prefix: 'https://steamcommunity.com/id/', placeholder: 'username' },
  'PlayStation': { prefix: 'https://psnprofiles.com/', placeholder: 'username' },
  'Xbox': { prefix: 'https://account.xbox.com/profile?gamertag=', placeholder: 'gamertag' },
  'Roblox': { prefix: 'https://roblox.com/users/', placeholder: 'user-id/username' },
  
  // Business & Reviews
  'Yelp': { prefix: 'https://yelp.com/user_details?userid=', placeholder: 'user-id' },
  'Tripadvisor': { prefix: 'https://tripadvisor.com/Profile/', placeholder: 'username' },
  'Foursquare': { prefix: 'https://foursquare.com/', placeholder: 'username' },
  'IMDB': { prefix: 'https://imdb.com/name/', placeholder: 'name-id' },
  'Letterboxd': { prefix: 'https://letterboxd.com/', placeholder: 'username' },
  
  // Reading
  'Goodreads': { prefix: 'https://goodreads.com/user/show/', placeholder: 'user-id' },
  
  // Crypto & Finance
  'Bitcoin': { prefix: 'bitcoin:', placeholder: 'address' },
  'Ethereum': { prefix: 'ethereum:', placeholder: 'address' },
  'PayPal': { prefix: 'https://paypal.me/', placeholder: 'username' },
  'Patreon': { prefix: 'https://patreon.com/', placeholder: 'username' },
  
  // Shopping
  'Amazon': { prefix: 'https://amazon.com/shop/', placeholder: 'shop-name' },
  'eBay': { prefix: 'https://ebay.com/usr/', placeholder: 'username' },
  'Shopify': { prefix: 'https://', placeholder: 'store-name.myshopify.com' },
  
  // Others
  'Strava': { prefix: 'https://strava.com/athletes/', placeholder: 'athlete-id' },
  
  // Contact 
  'Email': { prefix: 'mailto:', placeholder: 'your@email.com' },
  'Phone': { prefix: 'tel:', placeholder: '+1234567890' },
  'Website': { prefix: 'https://', placeholder: 'yourwebsite.com' },
  'Location': { prefix: 'https://maps.google.com/?q=', placeholder: 'address' },
  'Home': { prefix: 'https://', placeholder: 'yourhomepage.com' },
  'RSS Feed': { prefix: 'https://', placeholder: 'site.com/feed' },
  
  // Simplified Icons - use the same patterns as their regular counterparts
  'Facebook (Simple)': { prefix: 'https://facebook.com/', placeholder: 'username' },
  'Instagram (Simple)': { prefix: 'https://instagram.com/', placeholder: 'username' },
  'Twitter (Simple)': { prefix: 'https://twitter.com/', placeholder: 'username' },
  'LinkedIn (Simple)': { prefix: 'https://linkedin.com/in/', placeholder: 'username' },
  'YouTube (Simple)': { prefix: 'https://youtube.com/@', placeholder: 'username' },
  'GitHub (Simple)': { prefix: 'https://github.com/', placeholder: 'username' },
  'Email (Simple)': { prefix: 'mailto:', placeholder: 'your@email.com' },
  'Phone (Simple)': { prefix: 'tel:', placeholder: '+1234567890' },
  'Website (Simple)': { prefix: 'https://', placeholder: 'yourwebsite.com' },
  'Location (Simple)': { prefix: 'https://maps.google.com/?q=', placeholder: 'address' },
};

export default socialUrlPatterns;